module.exports = __webpack_public_path__ + "img/product.656d0297.png";